// PR #9 (2026-10-05): a PATIENT's own pick (the times they submitted on the
// T-01 scheduling link) as the CRM shows it. Pure helpers, unit-tested in
// pickWindows.test.js.

export function isPatientPickRequest(req) {
  return !!req && req.submitted_by === "patient-link" && req.status === "pending";
}

// "West Star Anaheim": BigQuery names every WestStar clinic plain "West Star",
// so the roster city is appended unless the name already carries it. Accepts
// the list row's `patient_pick` (clinic_name/clinic_city) or the panel's
// `request.clinic` (name/city).
export function pickClinicLabel(c) {
  const name = String(c?.clinic_name ?? c?.name ?? "").trim();
  const city = String(c?.clinic_city ?? c?.city ?? "").trim();
  if (!name) return "";
  return city && !name.toLowerCase().includes(city.toLowerCase()) ? `${name} ${city}` : name;
}

const t12 = (t) => {
  const [h, m] = String(t).split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m || 0).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

// "Wed, Oct 7 3:00 PM–6:00 PM · Fri, Oct 9 8:00 AM–12:00 PM". Dates are wall
// dates anchored at noon, so no viewer timezone can shift the day.
export function formatPickWindows(times) {
  if (!times || !times.length) return "Times not available — call the patient.";
  return times
    .map((t) => {
      const day = new Date(`${t.date}T12:00:00`).toLocaleDateString("en-US", {
        weekday: "short", month: "short", day: "numeric",
      });
      return `${day} ${t12(t.start_time)}–${t12(t.end_time)}`;
    })
    .join(" · ");
}
